import { type ReactNode, useEffect } from "react";
import { useAuthenticatedUser } from "./AuthenticatedUserProvider";

declare const pendo: {
	initialize: (payload: any) => {
		visitor: { id: string; email: string; firstName: string; lastName: string };
		account: { id: string };
	};
};

export const PendoProvider = ({ children }: { children: ReactNode }) => {
	const { user } = useAuthenticatedUser();
	useEffect(() => {
		if (user.setupComplete) {
			const visitorData = {
				id: user.id,
				email: user.email,
				firstName: user.firstName,
				lastName: user.lastName,
				role: user.type === "admin" ? user.roles[0] : user.role,
			};

			const initializeOptions = {
				visitor: visitorData,
				...(user.type === "agent" &&
					user.agencyId && {
						account: {
							id: user.agencyId,
						},
					}),
			};

			pendo.initialize(initializeOptions);
		}
	}, [user]);

	return <>{children}</>;
};
